<template>
  <div>
    <wc-section-title title='Staffing'></wc-section-title>
    <router-view></router-view>
  </div>
</template>

<script>
export default {
  name: 'staffing-base',
  computed: {
    menu () {
      return [
        {
          title: this.$store.state.icons.modules.staffing.title,
          icon: this.$store.state.icons.modules.staffing.icon,
          route: { name: 'StaffingDashboard' }
        }
      ]
    }
  },
  mounted () {
    this.$store.dispatch('loadMainMenuTitle', 'Staffing Menu')
    this.$store.dispatch('loadMainMenu', this.menu)
  }
}
</script>
